{
  "backButton": "Gå tilbake til {prevMenuButton}",
  "moreActions": "Flere handlinger",
  "unavailable": "Utilgjengelig, utvid for detaljer"
}
